import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { ApiFilterBase } from "@skailer-com/uikit/core";
import { ApiNotificationChannelType } from "@/types/notification.types.ts";

export interface ApiReminderSend {
  entity_type: ReminderEntityType;
  entity_ids: number[];
  recipient_employee_ids: number[];
  channels: ApiNotificationChannelType[];
  custom_subject: string | null;
  custom_body: string | null;
}

export interface ApiReminderHistoryFilter extends ApiFilterBase {
  entity_type: ReminderEntityType;
  entity_ids: number[];
}

export interface ApiReminderHistory {
  notification_id: number;
  entity_type: ReminderEntityType;
  entity_id: number;
  author: ApiEmployee;
  recipient: ApiEmployee;
  channels: ApiNotificationChannelType[];
  datetime_sent_at: Date;
}

export enum ReminderEntityType {
  performance_review = "performance_review",
  survey = "survey",
  task = "task",
}

export enum ReminderMode {
  light = "light",
  medium = "medium",
  hard = "hard",
  custom = "custom",
}

export interface ReminderSettings {
  channels: ApiNotificationChannelType[];
  custom_subject: string | null;
  custom_body: string | null;
  mode: ReminderMode;
  custom_frequency: number | null;
  custom_period: ReminderPeriod | null;
}

export interface ReminderSettingsPayload {
  channels: ApiNotificationChannelType[];
  custom_subject: string | null;
  custom_body: string | null;
  mode: ReminderMode | null;
  custom_frequency?: number | null;
  custom_period?: ReminderPeriod | null;
}

export enum ReminderPeriod {
  month = "month",
  day = "day",
  week = "week",
}
